import { useCallback, useRef } from 'react';

export const useLoadingElement = (
  loading: boolean,
  hasMore: boolean,
  callBack: () => void
) => {
  const observer = useRef<IntersectionObserver | null>(null);

  const loadingElement = useCallback(
    (node: HTMLElement | null) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting && hasMore && !loading) {
            callBack();
          }
        },
        { threshold: 1 }
      );

      if (node) observer.current.observe(node);
    },
    [loading, hasMore, callBack]
  );

  return loadingElement;
};
